import api from '../axios';
import type { propsRequestUpdateProfileBody, propsResponseMe } from '../interfaces';

export function getMe(): Promise<propsResponseMe> {
  return api.get('/v1/me');
}

export function updateMeProfile(body: propsRequestUpdateProfileBody) {
  return api.patch('/v1/me/profile', body);
}

export function updateMePassword(payload: {
  currentPassword: string;
  newPassword: string;
}) {
  return api.patch('/v1/me/password', payload);
}
